module.exports = __webpack_public_path__ + "img/gc_country_flag_ca.132456b9.svg";